import { List, ListRoot } from '@chakra-ui/react'
import { EditorPanelItem } from '@editor/interfaces/editor'

interface LayerSimpleProps {
  item: EditorPanelItem
}

const LayerSimple = ({ item: { name, displayName, children, isCountable, defaultCollapsed } }: LayerSimpleProps) => (
  <List.Item>
    {displayName || name} {isCountable && children ? `(${children.length})` : ''}
    {children?.length && !defaultCollapsed ? (
      <ListRoot>
        {children.map((child) => (
          <LayerSimple key={child.key} item={child} />
        ))}
      </ListRoot>
    ) : null}
  </List.Item>
)

export default LayerSimple
